// extracted by mini-css-extract-plugin
export default {"Book":"BookDetail_Book__4Pr0X","card":"BookDetail_card__HBmBF","tableDataTitle":"BookDetail_tableDataTitle__svWbR"};